<template>
  <div :class="['chart-container', noMargin && 'no-margin']">
    <slot />
  </div>
</template>

<script>
export default {
  name: "chart-container",
  props: {
    noMargin: Boolean
  }
};
</script>

<style scoped>
.chart-container,
.chart-container > div {
  height: 100%;
  width: 90%;
  position: relative;
  margin: 0 auto;
}

.no-margin > div {
  left: -10%;
  /* margin: 0 0 !important;
  width: 110%; */
}
</style>
